/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  alertBox: {
    boxShadow:
      "rgba(9, 30, 66, 0.28) 0px 4px 8px -2px, rgba(9, 30, 66, 0.3) 0px 0px 1px;",
    fontSize: "12px",
    lineHeight: "20px",
    marginBottom: "16px",
    transform: "rotateX(0deg)",
    transformOrigin: "50% 0px",
    transitionProperty:
      "visibility, height, margin-bottom, opacity, transform, padding",
    transitionDuration: "0s, 0.2s, 0.2s, 0.2s, 0.2s",
    transitionTimingFunction: "ease-in-out",
    borderRadius: "3px",
    padding: "16px",
  },
  formButton: {
    marginTop: "20px",
  },
}));

export default function AlertMessageComponent({ message }) {
  const classes = useStyles();

  return <div className={classes.alertBox}>{message}</div>;
}
